import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from 'src/app/services/auth-service';
import { NagadConfigService } from 'src/app/services/nagad-config.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ng-documentation',
  templateUrl: './ng-documentation.component.html',
  styleUrls: ['./ng-documentation.component.scss'],
})
export class NgDocumentationComponent {
  successRes = `
  { 
    "statusCode": 200, 
    "message": "Successful", 
    "data": [ 
        { 
            "serviceId": "0000000000", 
            "title": "Title 01", 
            "validity": "Monthly", 
            "price": 0.0 
        }, 
        { 
            "serviceId": "0000000000", 
            "title": "Title 02", 
            "validity": "Daily", 
            "price": 0.0 
        }, 
        { 
            "serviceId": "0000000000", 
            "title": "Title 03", 
            "validity": "Weekly", 
            "price": 0.0 
        } 
    ] 
} `;
  wrongServiceRes = `
    { 
        "statusCode": 500, 
        "message": "Something went wrong! Please try again.", 
        "data": null 
    }`;

  reqBody = `
    { 
        "MSISDN": "880100000000", 
        "ServiceId": "2251" ,
        "PaymentSuccessRedirectUrl" : "https://www.example.com/success",
        "PaymentFailedRedirectUrl" : "https://www.example.com/failed"
    } 
 `;
  reqSucRes = `
    { 
        "statusCode": 200, 
        "message": "Successfull" 
    }
 `;
  otpVerifyReqBody = `
 { 
    "MSISDN": "880100000000", 
    "ServiceId": "000000000", 
    "ConsentNo": "00000" 
} `;

  optVerifySucRes = `
{ 
    "statusCode": 200, 
    "message": "Successfull" 
} `;

  optVerifyServerError = `
{ 
    "statusCode": 500, 
    "message": "Something went wrong! Please try again.", 
    "data": null 
}  `;

  reqServerErrorRes = `
    { 
        "statusCode": 500, 
        "message": "Something went wrong! Please try again.", 
        "data": null 
    }  
 `;
  checkReqRes = `
  {
     "statusCode": 200,
     "message": "Successful",
     "data": {
         "msisdn": "880100000000",
         "serviceId": "00000000",
         "nextRenewalDate": 0
     }
 }`;
  checkNotFoundRes = `
    {
        "statusCode": 200,
        "message": "Not found any subscription",
        "data": null
    }
 `;
  subscriptionCheckApiNotFoundRes = `
 {
     "statusCode": 200,
     "message": "Not found any subscription",
     "data": null
 }
`;
  cancelReq = `
 {
     "statusCode": 200,
     "message": "Successful"
 }
 `;
  cancelRes = `
 {
     "statusCode": 200,
     "message": "Failed"
 }
 '`;
  vendor: string | null = null;
  apiRouteSegment: string = 'api';
  domain = environment.nagadApiUrl;
  checkSubscriptionApi: string = '';
  checkSubscriptionApiWithTrue: string = '';
  cancelSubscriptionApi: string = '';
  productsApi: string = '';
  createCheckoutSessionApi: string = '';
  verifyCheckoutSessionApi: string = '';

  constructor(
    private config: NagadConfigService,
    private route: ActivatedRoute,
    public authService: AuthService,

    private message: NzMessageService
  ) {
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.config.getDetailsByMarchent(params['id']).subscribe((e) => {
          console.log(e);
          if (e && e.length > 0) {
            this.vendor = e[0].merchant;

            this.initializeApiRoutes();
          }
        });
      }
    });

    this.route.queryParams.subscribe((params) => {
      const serviceProvider: string = params['serviceProvider'];
    });
  }

  getMessage() {
    return `No service provider found please contact with administrator.`;
  }

  initializeApiRoutes() {
  
    this.checkSubscriptionApi = `${this.domain}/${this.apiRouteSegment}/billing/check-subscription/${this.vendor}/8800000000000?isShowAll=false`;
    this.checkSubscriptionApiWithTrue = `${this.domain}/${this.apiRouteSegment}/billing/check-subscription/${this.vendor}/8800000000000?isShowAll=true`;
    this.cancelSubscriptionApi = `${this.domain}/${this.apiRouteSegment}/billing/cancel-subscription`;
    this.productsApi = `${this.domain}/${this.apiRouteSegment}/billing/products/${this.vendor}`;
    this.createCheckoutSessionApi = `${this.domain}/${this.apiRouteSegment}/checkout/create-checkout-session`;
    this.verifyCheckoutSessionApi = `${this.domain}/${this.apiRouteSegment}/checkout/verify-checkout-session`;
  }
}
